import { render, staticRenderFns } from "./index.vue?vue&type=template&id=5c97c3c2&scoped=true"
import script from "./_index.js?vue&type=script&lang=js&external"
export * from "./_index.js?vue&type=script&lang=js&external"
import style0 from "./_index.scss?vue&type=style&index=0&id=5c97c3c2&prod&lang=scss&scoped=true&external"
import style1 from "./index.vue?vue&type=style&index=1&id=5c97c3c2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c97c3c2",
  null
  
)

export default component.exports